import { render } from "./NPromo.vue?vue&type=template&id=ac67c94a"
import script from "./NPromo.vue?vue&type=script&lang=js"
export * from "./NPromo.vue?vue&type=script&lang=js"

import "./NPromo.vue?vue&type=style&index=0&id=ac67c94a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__